<div class="search-div">
    <div style="margin-top: 15px; margin-left: 40px; display: flex; height: 37px;">
        <button mat-raised-button class="btn-color-example" (click)="onCreate()"><mat-icon>add</mat-icon>Add Candidates</button>
        <button mat-raised-button class="btn-color-example" style="margin-left: 10px;" (click)="onUpload()" matTooltip="Bulk upload for candidate through csv/excel">Upload csv/excel</button>
        <button mat-raised-button mat-button class="btn-color-example" [disabled]="syncButtonEnabler === false ? true : false" style="margin-left: 10px;" matTooltip="Fetch More Candidates" (click)="syncCandidates()">Sync Candidates</button>
        <div style="flex-direction: column;">
            <span id="myTimer" [ngStyle] = "syncButtonEnabler === false ? { 'color': '#252c61' } : { 'color': '#fafafa' }">00.05</span>
            <div id="remaining-label" [ngStyle] = "syncButtonEnabler === false ? { 'color': '#252c61' } : { 'color': '#fafafa' }" class="remaining-label">Remaining</div>
        </div>
       
        <!-- <button mat-raised-button class="btn-color-example" style="margin-left: 10px;" (click)="csvInput.click()" matTooltip="Bulk upload for candidate through csv/excel">Upload csv/excel</button>
        <input #csvInput hidden="true" type="file" onclick="this.value=null" (change)="csvInputChange($event.target.files)" accept=".csv, .xls, .xlsx"/>  -->

    </div>
    <mat-form-field class="search-form-field">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search candidate details" [(ngModel)]="filterName" name="filterName">
        <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)= "onClear()">
        <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div>
<!-- <div class="upload-progress">
  {{percentCompleted}}% Uploaded
  <mat-progress-bar mode="determinate" value="40"></mat-progress-bar>
  <div *ngIf="isSingleUploaded" class="success">File uploaded successfully</div>
</div> -->
<!-- <div class="my-class" [ngClass]="status ? 'upload-show' : 'upload-hide'">
  <span>Only .xlsx & .xls extensions file can be acceptable </span>
</div> -->

<!-- <div class="download-templete">
    <a href="./assets/Candidate.xlsx" class="btn clss" target="_self" 
        matTooltip="Download the excel/csv format for bulk upload"  matTooltipPosition="above"
        download>Download Template
    </a>
</div> -->
<div  class="mat-elevation-z8" style="margin-left: 40px; margin-right: 25px;">
    <mat-table [dataSource]="listData" matSort>

        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <!-- <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sl No. </th>
            <td mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </td>
        </ng-container> -->

        <!-- Name Column -->
        <ng-container matColumnDef="candidateName">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Candidate Name </mat-header-cell>
            <mat-cell *matCellDef="let element" class="ellipses" (click)=copyToClipboard(element.candidateName) matTooltip= {{element.candidateName}}> 
                {{element.candidateName}}
            </mat-cell>
        </ng-container>

        <!-- Email-Id Column -->
        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
            <mat-cell *matCellDef="let element" class="ellipses" (click)=copyToClipboard(element.email) matTooltip= {{element.email}}> 
                {{element.email}} 
            </mat-cell>
        </ng-container>

        <!-- Contact No. Column -->
        <ng-container matColumnDef="contactNo">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Contact No. </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.contactNo}} </mat-cell>
        </ng-container>

        <!-- City Column -->
        <ng-container matColumnDef="address">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Address </mat-header-cell>
            <mat-cell *matCellDef="let element" class="ellipses" (click)=copyToClipboard(element.address) matTooltip= {{element.address}}>
                {{element.address}}
            </mat-cell>
        </ng-container>

        <!-- Gender Column -->
        <ng-container matColumnDef="gender">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Gender </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.gender}} </mat-cell>
        </ng-container>

        <!-- DOB Column -->
        <ng-container matColumnDef="dob">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Date of Birth </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.dob}} </mat-cell>
        </ng-container>
        
        <!-- Attempted Status Column -->
        <ng-container matColumnDef="attemptStatus">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Attendance Status </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.attemptStatus}} </mat-cell>
        </ng-container>

        <!-- Total Score  Column -->
        <ng-container matColumnDef="totalMarks">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Total Marks </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div *ngIf="element.totalMarks === null; else totalMarksPart">N/A</div>
                <ng-template #totalMarksPart>{{element.totalMarks}}</ng-template>
            </mat-cell>
        </ng-container>

        <!-- Secured Score  Column -->
        <ng-container matColumnDef="score">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Marks Obtained </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <div *ngIf="element.score === null; else scorePart">N/A</div>
                <ng-template #scorePart>{{element.score}}</ng-template>
            </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> Actions Buttons</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.parentId === 0" matTooltip= "Edit Candidate Information" (click)="onEdit(element.candidateId)" style="font-size: 30px; color: #252c61;">edit</mat-icon>
                <mat-icon *ngIf="element.parentId === 1" matTooltip= "Can't edit Parent Candidate Information" style="font-size: 30px; color: #252c61;opacity:.5">edit</mat-icon>

                <!-- <button mat-icon-button [disabled]="element.parentId === 1 ? true : false" (click)="onEdit(element.candidateId)">
                    <mat-icon matTooltip= "Edit Candidate Information" style="font-size: 30px; color: #252c61;">edit</mat-icon>
                </button> -->
                <!-- <button mat-icon-button [disabled]="element.parentId === 1 ? true : false" (click)="onDelete(element.candidateId)">
                    <mat-icon style="font-size: 30px; color: #252c61">delete_outline</mat-icon>
                </button> -->
                <!-- <button mat-icon-button [disabled]="!this.deleteCandidateBtn" (click)="onDelete(element.candidateId)">
                    <mat-icon style="font-size: 30px; cursor: not-allowed;">delete_outline</mat-icon>
                </button> -->
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="loading">
            <mat-footer-cell style="height: 300px;" *matFooterCellDef colspan="6">
                No Data Available. Please Add or Upload Candidate Data.
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="6">
                No Data Available....................
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row"></mat-row>
        <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide':listData!=null}"></mat-footer-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide':!(listData!=null && listData.data.length==0)}">
        </mat-footer-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100]" showFirstLastButtons></mat-paginator>
    <div *ngIf="candidateListLoader" id="candidate-list-loader"></div>
</div>